<script>
import { h, resolveComponent, resolveDirective, withDirectives } from 'vue';

export default {
  name: 'cLabel',
  data() {
    return {};
  },
  emits: ['click'],
  props: {
    size: {
      type: Number,
      default: 14
    },
    lineHeight: {
      type: Number,
      default: null
    },
    color: {
      type: String,
      default: '#333333'
    },
    ellipsis: {
      type: Boolean,
      default: false
    },
    inline: {
      type: [Boolean, String],
      default: false
    },
    pointer: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    pre: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '100%'
    },
    weight: {
      type: Number,
      default: 400
    },
    icon: {
      type: String,
      default: ''
    },
    iconType: {
      type: String,
      default: ''
    },
    isLnb: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: Boolean,
      default: true
    }
  },
  computed: {},
  methods: {
    onClick() {
      this.$emit('click');
    }
  },
  render() {
    const {
      $theme,
      icon,
      iconType,
      ellipsis,
      size,
      lineHeight,
      width,
      color,
      weight,
      inline,
      pointer,
      required,
      pre,
      tooltip
    } = this;
    const getChildrenName = (childrens) => {
      if (Array.isArray(childrens)) {
        return childrens.length > 0 ? getChildrenName(childrens[0].children) : null;
      }
      return childrens;
    };
    const legoIcon = resolveComponent('lego-icon');
    const legoTooltip = resolveDirective('lego-tooltip');
    return withDirectives(
      h(
        'div',
        {
          class: {
            'c-label': true,
            'c-label--ellipsis': ellipsis,
            'c-label--pre': pre
          },
          style: {
            width: typeof inline == 'boolean' && inline ? 'inherit' : width,
            color,
            fontSize: `${size}px`,
            lineHeight: lineHeight ? `${lineHeight}px` : size === 13 ? '20px' : `${size * 1.5}px`,
            fontWeight: weight,
            display: typeof inline == 'boolean' && inline ? 'inline' : inline,
            cursor: pointer && 'pointer'
          },
          onClick: this.onClick
        },
        [
          icon &&
            h(legoIcon, {
              iconType: iconType,
              icon: icon,
              size: 16,
              color: this.isLnb ? '#B6C6F2' : color
            }),
          this.$slots.default && this.$slots.default(),
          required &&
            h(
              'span',
              {
                style: {
                  marginLeft: '4px',
                  fontSize: 14,
                  fontWeight: 700,
                  color: $theme.COLOR.STATUS.ERROR
                }
              },
              ['*']
            )
        ]
      ),
      [
        [
          tooltip && legoTooltip,
          ellipsis && this.$slots.default ? getChildrenName(this.$slots.default()) : null,
          'ellipsis'
        ]
      ]
    );
  }
};
</script>
<style lang="scss" scoped>
.c-label {
  &--ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }

  &--pre {
    white-space: pre-wrap;
  }

  :deep .lego-icon--prod {
    margin-right: 10px;
    opacity: 0.6;
    position: relative;
    top: 2px;
  }

  :deep .lego-icon--picto {
    margin-right: 10px;
    opacity: 0.6;
    position: relative;
    top: 2px;
  }
}
</style>
